export enum SalaryFrequency {
	PER_DAY = 'per-day',
	PER_MONTH = 'per-month',
	PER_YEAR = 'per-year'
}

export interface ISalary {
	min: number;
	max?: number;
	currency: string;
	frequency: SalaryFrequency;
}

export interface ICurrentSalary {
	value: number;
	currency: string;
	frequency: SalaryFrequency;
}
